import { Overrides } from '@material-ui/core/styles/overrides';

export const dialogOverrides: Overrides = {
  MuiDialog: {
    paper: {
      borderRadius: '8px'
    }
  }
};
